/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BroadcastEvBatteryAgreementBulkRequest } from '../models/BroadcastEvBatteryAgreementBulkRequest';
import type { GetEvBatteryAgreementResponse } from '../models/GetEvBatteryAgreementResponse';
import type { Vehicle } from '../models/Vehicle';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EvBatteryAgreementTestControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * case3 vehicle_features 저장
   * 현재 데이터 조회
   * @returns any OK
   * @throws ApiError
   */
  public createEvBatteryAgreementFeature({
    requestBody,
  }: {
    requestBody: Vehicle,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/{vin}/features',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * case3 vehicle_features 저장
   * 현재 데이터 조회
   * @returns any OK
   * @throws ApiError
   */
  public createEvBatteryAgreementFeature1({
    requestBody,
  }: {
    requestBody: Vehicle,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/{vin}/features/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * case3 동의전파
   * case3 동의전파
   * @returns any OK
   * @throws ApiError
   */
  public broadcastEvBatteryAgreement({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/{vin}/broadcast/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * case3 동의전파
   * case3 동의전파
   * @returns any OK
   * @throws ApiError
   */
  public broadcastEvBatteryAgreement1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/{vin}/broadcast',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * case3 vehicle_features 벌크 저장
   * 현재 데이터 조회
   * @returns any OK
   * @throws ApiError
   */
  public createBulkEvBatteryAgreementFeature({
    requestBody,
  }: {
    requestBody: BroadcastEvBatteryAgreementBulkRequest,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/features/bulk',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * case3 vehicle_features 벌크 저장
   * 현재 데이터 조회
   * @returns any OK
   * @throws ApiError
   */
  public createBulkEvBatteryAgreementFeature1({
    requestBody,
  }: {
    requestBody: BroadcastEvBatteryAgreementBulkRequest,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/features/bulk/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * case 별 철회전파
   * case3 가 아니면 동의대상이 아니기 때문에, 철회전파
   * @returns any OK
   * @throws ApiError
   */
  public revokeByCase({
    requestBody,
  }: {
    requestBody: BroadcastEvBatteryAgreementBulkRequest,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/case/revoke',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * case 별 철회전파
   * case3 가 아니면 동의대상이 아니기 때문에, 철회전파
   * @returns any OK
   * @throws ApiError
   */
  public revokeByCase1({
    requestBody,
  }: {
    requestBody: BroadcastEvBatteryAgreementBulkRequest,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/case/revoke/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 벌크 hmg-api 동의전파
   * case3 동의전파
   * @returns string OK
   * @throws ApiError
   */
  public bulkBroadcastEvBatteryAgreement({
    requestBody,
  }: {
    requestBody: BroadcastEvBatteryAgreementBulkRequest,
  }): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ev-battery/agreement/test/broadcast/bulk',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 할부여부 확인
   * 할부여부 확인
   * @returns boolean OK
   * @throws ApiError
   */
  public installment({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/agreement/test/{vin}/installment/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 할부여부 확인
   * 할부여부 확인
   * @returns boolean OK
   * @throws ApiError
   */
  public installment1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/agreement/test/{vin}/installment',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 현재 데이터 조회
   * 현재 데이터 조회
   * @returns GetEvBatteryAgreementResponse OK
   * @throws ApiError
   */
  public getBatteryAgreementInfo({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<GetEvBatteryAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/agreement/test/{vin}/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 현재 데이터 조회
   * 현재 데이터 조회
   * @returns GetEvBatteryAgreementResponse OK
   * @throws ApiError
   */
  public getBatteryAgreementInfo1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<GetEvBatteryAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/agreement/test/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
}
